module.exports = __webpack_public_path__ + "img/uk.12073fbd.jpg";